import React from "react";
import {
  FaGlobe,
  FaInstagram,
  FaTwitch,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
export default function PlayerSocials({ socials, position }) {
  return (
    <span className=" social-card2 py-1">
      {socials.instagram && (
        <a
          href={socials.instagram}
          target="_blank"
          rel="noreferrer"
          className="mx-1 "
        >
          <FaInstagram size={18} className="social_link" />
        </a>
      )}
      {socials.youtube && (
        <a
          href={socials.youtube}
          target="_blank"
          rel="noreferrer"
          className="mx-1"
        >
          <FaYoutube size={18} className="social_link" />
        </a>
      )}
      {socials.twitter && (
        <a
          href={socials.twitter}
          target="_blank"
          rel="noreferrer"
          className="mx-1"
        >
          <FaTwitter size={18} className="social_link" />
        </a>
      )}
      {socials.twitch && (
        <a
          href={socials.twitch}
          target="_blank"
          rel="noreferrer"
          className="mx-1"
        >
          <FaTwitch size={18} className="social_link" />
        </a>
      )}
      {socials.website && (
        <a
          href={socials.website}
          target="_blank"
          rel="noreferrer"
          className="mx-1"
        >
          <FaGlobe size={18} className="social_link" />
        </a>
      )}
    </span>
  );
}
